import { useTranslation } from "react-i18next";
import { RootState } from "../../store/store";
import { useDispatch, useSelector } from "react-redux";
import { useContext } from "react";
import { SocketContext } from "../../context/socket";
import {
  setCode,
  setCurrentPage,
  setPlayersNumber,
} from "../../store/slices/PlayerSlice";
import { Helmet } from "react-helmet";

export function Over() {
  const { t } = useTranslation();
  const room = useSelector((state: RootState) => state.player.code);
  const name = useSelector((state: RootState) => state.player.playerName);
  const socket = useContext(SocketContext);
  const dispatch = useDispatch();

  const sendNext = (response: string, id: string, playerName: string) => {
    socket.emit(response, { roomId: room, name: name });
    switch (response) {
      case "NEW_GAME":
        dispatch(setCurrentPage("waiting"));
        dispatch(setPlayersNumber(2));
        break;
      case "PLAY_AGAIN":
        dispatch(setCurrentPage("waiting"));
        break;
      case "EXIT_GAME":
        dispatch(setCurrentPage("join"));
        socket.emit("LEAVE_ROOM", { roomId: id, name: playerName });
        dispatch(setCode(""));
        break;
    }
  };

  return (
    <div className="player-game-min flex w-screen flex-col items-center justify-start gap-4 overflow-x-hidden overflow-y-auto bg-over bg-cover bg-right bg-repeat-x px-4 py-6 player-game-safe-y">
      <Helmet>
        <title>Propaganda: Game Ended</title>
        <meta name="description" content="Game ended screen."></meta>
      </Helmet>
      <h3 className="max-w-xl text-center font-Cairo text-2xl font-bold text-dark-blue xs:text-3xl phone:text-3xl desktop:text-6xl">
        {t("results.play_again")}
      </h3>
      <button
        className="h-12 w-[90%] max-w-md rounded-lg border-2 border-white bg-orange font-Cairo text-lg text-dark-blue desktop:h-14 desktop:text-2xl"
        onClick={() => sendNext("NEW_GAME", room, name)}
      >
        {t("results.yes_diff")}
      </button>
      <button
        className="h-12 w-[90%] max-w-md rounded-lg border-2 border-white bg-orange font-Cairo text-lg text-dark-blue desktop:h-14 desktop:text-2xl"
        onClick={() => sendNext("PLAY_AGAIN", room, name)}
      >
        {t("results.yes_same")}
      </button>
      <button
        className="h-12 w-[90%] max-w-md rounded-lg border-2 border-white bg-light_green font-Cairo text-xl text-dark-blue desktop:h-14 desktop:text-3xl"
        onClick={() => sendNext("EXIT_GAME", room, name)}
      >
        {t("results.exit")}
      </button>
    </div>
  );
}
